import React, { useState } from 'react';
import classes from '../List.module.scss';
import { DSArrowDownIcon, DSInformationIcon } from '@design-system/icons';
import { Tooltip } from '@design-system/components/tooltips';
import cx from 'classnames';

export type GroupItemData<T> = {
  title: string;
  itemList: T[];
  infoText?: string;
  isExpanded?: boolean;
};
type SearchableListGroupProps<T> = {
  groupData: GroupItemData<T>;
  stickyHeadersEnabled: boolean;
  children: (item: T) => React.ReactNode;
  groupName?: string;
};
const SearchableListGroup = <T extends object>({
  groupData,
  stickyHeadersEnabled,
  children,
  groupName
}: SearchableListGroupProps<T>) => {
  const isExpandable = groupData.isExpanded !== undefined;
  const { title, isExpanded = true, infoText, itemList } = groupData;
  const [groupIsExpanded, setGroupIsExpanded] = useState(isExpanded);

  const headerClick = () => {
    if (!isExpandable) return;

    setGroupIsExpanded(prev => !prev);
  };

  return (
    <>
      <div
        className={cx(classes.groupHeader, {
          [classes.isExpandable]: isExpandable,
          [classes.groupIsExpanded]: groupIsExpanded,
          [classes.isSticky]: stickyHeadersEnabled
        })}
        onClick={headerClick}
      >
        <div className={classes.groupHeaderTitle}>
          <span>{title}</span>
          {Boolean(infoText) && (
            <Tooltip content={infoText} className={classes.groupHeaderInfo}>
              <DSInformationIcon />
            </Tooltip>
          )}
        </div>
        {isExpandable && (
          <div
            data-test={`${groupName}-group-icon`}
            className={classes.groupHeaderIcon}
          >
            <DSArrowDownIcon />
          </div>
        )}
      </div>
      {groupIsExpanded && (
        <div className={classes.groupBody}>
          {itemList.map(item => children(item as T))}
        </div>
      )}
    </>
  );
};

export default SearchableListGroup;
